class StatusDevolucaoEnum {
    constructor(status, cod) {
      this.status = status;
      this.cod = cod;
    }
  
    static fromCodStatus(cod) {
      return Object.values(StatusDevolucaoEnum).find(status => status.cod === cod);
    }
  
    static fromStatus(status) {
      return Object.values(StatusDevolucaoEnum).find(s => s.status === status);
    }
  }
  
  StatusDevolucaoEnum.EM_DIGITACAO = new StatusDevolucaoEnum("Em Digitação", 26);
  StatusDevolucaoEnum.EM_ANDAMENTO = new StatusDevolucaoEnum("Em Andamento", 28);
  StatusDevolucaoEnum.FINALIZADO = new StatusDevolucaoEnum("Finalizado", 33);


  export default StatusDevolucaoEnum;
  
  